import axios from 'axios';
export async function getjson( cfile:string) {
    // 同步请求
    let res = null;    
    try {
      res = await axios({
        url: cfile,
        method: 'post',
      }).then(res =>{            
        return res;
        });           
    } catch (err) {
      console.log(err);
    }    
    return res;
  };